import { render, staticRenderFns } from "./ListaOrcamentos.vue?vue&type=template&id=5806e6e3&"
import script from "./ListaOrcamentos.vue?vue&type=script&lang=js&"
export * from "./ListaOrcamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports